import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import type { Nil } from '@pbt/pbt-ui-components'

import MetadataList from '~/components/common/MetadataList'
import { fetchBusiness } from '~/store/actions/businesses'
import { getBusiness } from '~/store/reducers/businesses'

const BusinessCommunication = ({
  businessId,
}: {
  businessId: string | Nil
}) => {
  const { t } = useTranslation(['Common'])
  const dispatch = useDispatch()
  const business = useSelector(getBusiness(businessId))

  const hasRequiredFields = business?.communicationsPhone && business?.email

  useEffect(() => {
    if (businessId && !hasRequiredFields) {
      dispatch(fetchBusiness(businessId))
    }
  }, [businessId])

  if (!businessId) {
    return null
  }

  return (
    <MetadataList
      items={[
        { value: business?.name || '' },
        { value: business?.communicationsPhone || '' },
        { value: business?.email || '' },
      ]}
      prefix={`${t('Common:TO')}: `}
    />
  )
}

export default BusinessCommunication
